/**
 * Look of a totals row, kept in a leaf module with no imports of its own: `PlainTable` lives in
 * `stories/` and pulling the `utils` barrel in through `components/TableTotals` would add an
 * import cycle to a module that renders on every screen.
 */

/** Type/weight/rule that separate a totals row from the body it sums. */
export const TOTALS_ROW_CLASS = 'text-[14.5px] font-semibold text-gray-900 border-t-2 border-slate-300'

/** Opaque ground, so a sticky totals row does not show the body scrolling underneath it. */
export const TOTALS_CELL_BG = 'bg-slate-50 dark:bg-gray-700'
